import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/Layout'
import Seo from '../components/seo'
import Hero from '../components/Hero'
import Distributions from '../components/Distributions'

const NodePage = ({ data }) => {
  const { contentfulPage } = data
  const { hero, sections, image } = contentfulPage
  const { coverImage, headLine } = hero
  const { file: { url, fileName } } = image
  const [menuOption, setMenuOption] = React.useState('debian-and-ubuntu-based-distributions')

  return (
    <Layout>
      <Seo title='NodeJS Binary Distributions' description={headLine} />
      <Hero title={headLine} image={coverImage} />
      <section className='pull-top-100px'>
        <div className='container'>
          <div className='row'>
            <Distributions.Menu setMenuOption={setMenuOption} />
            <div className='col-lg-8 background-white'>
              <div className='margin-bottom-30px'><img src={url} alt={fileName} /></div>
              <div className='post-entry'>
                <p>
                This repository contains documentation for using the <a href='https://nodesource.com'>NodeSource</a> <a href='http://nodejs.org'>NodeSource</a> Binary Distributions via .rpm, .deb and Snap packages as well as their setup and support scripts.
                </p>
                <p>If you are looking for NodeSource's low-impact Node.js performance monitoring platform, please <a href='https://accounts.nodesource.com/sign-up-linuxdistro'>get started here</a>.</p>
                <p>Please file an issue if you are experiencing a problem or would like to discuss something related to the distributions.</p>
                <p>Pull requests are encouraged if you have changes you believe would improve the setup process or increase compatibility across Linux distributions.</p>
              </div>
              <Distributions.Section sections={sections} menuOption={menuOption} />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default NodePage

export const pageQuery = graphql`
  query DistributionsPage {
    contentfulPage(typePage: {eq: "distribution"})  {
      hero {
        headLine
        coverImage {
          file {
            fileName
            url
          }
        }
      }
      image {
        file {
          fileName
          url
        }
      }
      sections {
        sectionPage {
          childMarkdownRemark {
            html
          }
        }
        sectionTitle
        slug
      }
    }
  }
`
